// extracted by mini-css-extract-plugin
module.exports = {"cardTitleContainer":"CompanyEmployees_cardTitleContainer__84bXl","modal":"CompanyEmployees_modal__1P9Gh"};